<template>
  <div
    class="input-group"
    :class="`input-group-${variant} ${getStatus(error, success)}`"
  >
    <label :class="variant === 'static' ? '' : 'form-label'">{{ label }}</label>
    <input
      :id="id"
      :type="type"
      class="form-control"
      :class="getClasses(size)"
      :name="name"
      :value="modelValue"
      :placeholder="placeholder"
      :required="isRequired"
      :disabled="disabled"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script>
import setMaterialInput from "@/assets/js/material-input.js";

export default {
  name: "MaterialInput",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "outline",
    },
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  mounted() {
    setMaterialInput();
  },
  methods: {
    getClasses(size) {
      return size ? `form-control-${size}` : null;
    },
    getStatus(error, success) {
      if (success) return "is-valid";
      if (error) return "is-invalid";
      return null;
    },
  },
};
</script>

<style scoped>
.input-group .form-control {
  border: 1px solid #b03a45;
  transition: border-color 0.2s;
}
.input-group .form-control:focus {
  border-color: #b03a45 !important;
  box-shadow: 0 0 0 0.1rem rgba(176, 58, 69, 0.25);
}
.input-group .form-label {
  color: #b03a45;
}
.input-group.is-valid .form-control {
  border-color: #b03a45 !important;
}
.input-group.is-invalid .form-control {
  border-color: #dc3545 !important;
}
</style>
